import axios from "axios";
import { SET_LOADER, CLEAR_LOADER, CLEAR_ERRORS } from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - ADD OFFERS AND EVENTS ACTION
 *****************************************/
export const change_password_vendor = (formData, token, callback) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let change_password_vendor = await axios.patch(
      `${serverApi}/vendor-change-password`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (change_password_vendor.data) {
      dispatch({ type: CLEAR_LOADER });
      Alert.success(`<h4>Password Change Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      callback();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
